/*
 * URL組み立て系の共通関数
 *   packages/shared-ui/utils/url.tsの拡張
 */

import * as url from "@shared-ui/utils/url";

// 環境に応じたURLを返却
export const path = (p: string) => url.path(import.meta.env.BASE_URL, p);
